import { useAvailabilityFormatter } from "PFCore/helpers/availability";
import { AvailabilityRule, MatchedActivity, MatchPreference } from "PFTypes";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { MatchedPreference } from "../../../../../../components/matched_preferences";
import { Section } from "../../../../components";
import css from "./availability_section.module.scss";

type AvailabilitySectionProps = {
  role: MatchedActivity["activity"];
  className?: string;
};

export const AvailabilitySection = ({ role, className }: AvailabilitySectionProps): JSX.Element | null => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.roleDetails.availability" });

  const { availabilityRangesFormat, availabilityIntervalFormat } = useAvailabilityFormatter();

  const availability = role.metadata.availability as AvailabilityRule;

  const availabilityContent = useMemo(() => {
    if (!availability) {
      return null;
    } else if (availability.mode === "time_rule") {
      return availabilityRangesFormat(availability, true, css.availabilityRange);
    }

    return availabilityIntervalFormat(availability);
  }, [availability, availabilityRangesFormat, availabilityIntervalFormat]);

  if (!availabilityContent) {
    return null;
  }

  const isDurationMatched = role.matched_by.includes(MatchPreference.Duration);

  return (
    <Section
      title={t("title")}
      headerAdditionalContent={
        isDurationMatched ? (
          <MatchedPreference match={MatchPreference.Duration} label={t(`preference.duration`)} />
        ) : undefined
      }
      className={className}
    >
      <div className={css.availabilityContent}>{availabilityContent}</div>
    </Section>
  );
};
